import { action, observable } from "mobx"
import notie                  from "notie"
import Products               from "./Products/Products"
import Cart                   from "./cart/Cart"
import Typeahead              from "./Typeahead"
import Filter                 from "./filter/Filter"
import Auth                   from "./Auth/Auth"
import CategoryModel          from "shop/CategoryModel"
import OrderlistService       from "./OrderlistService"
import Analytics              from "./Analytics"
import ProductModel           from "./ProductModel"
import _                      from "lodash"
import Signal                 from "./Signal"
import store                  from "store"
import $fetch                 from "./$fetch"
import app                    from "app.controller"
import cmsStore               from "stores/cmsStore"
import productStore           from "stores/productStore"
import languageStore          from "stores/languageStore";


export default class Api {
  @observable session
  @observable locationAfterLogin

  @action
  setLocationAfterLogin( to ) {
    this.locationAfterLogin = to
  }

  get config() {
    return cmsStore.config
  }

  set config( config ) {
    cmsStore.config = config
  }

  constructor( config ) {
    this.config = config
    window.__bshop_config = config

    console.log( "VERSION", process.env.VERSION )
    // default models
    this.ProductModel = config.ProductModel || ProductModel
    this.CategoryModel = config.CategoryModel || CategoryModel

    this.model = {}
    this.model.Product = ProductModel

    this.typeahead = new Typeahead( {
                                      config,
                                      shop: this
                                    } )

    this.events = {}
    this.events.login = new Signal()
    this.events.logout = new Signal()
    this.events.authentified = new Signal()
    this.events.authentified.memorize = true
    this.events.loaded = new Signal()
    this.events.loaded.memorize = true

    this._prepareCategories( config )

    let auth = new Auth( {
                           shop: this,
                           signal: this.events.authentified,
                           config
                         } )

    this.login = ( { user, password } ) => auth.auth( {
                                                        user,
                                                        password
                                                      } )

    this.logout = () => {
      this.cart && this.cart.reset()
      return auth.logout()
    }

    this.whoami = function () {
      return auth.whoami()
    }

    this.service = {}
    this.service.request = async ( id, form ) => {

      const fileInput = document.querySelector( ".Form input[type=file]" )
      if ( fileInput ) {
        const fileName = fileInput.name
        if ( fileName ) {
          const [attr0, attr1] = fileName.split( "." )
          let firstFile = fileInput.files[ 0 ]
          if ( firstFile ) {
            try {
              let { file, id } = await this.service.upload( firstFile )
              if ( file && id ) {
                let field = form[ attr0 ] || {}
                field[ attr1 ] = id
                form[ attr0 ] = field
                console.log( "appended file", { file, id } )
              }
            }
            catch (err) {
              console.error( "Error Uploading file", err )
              return false
            }
          }
        }
      }

      form.locale = languageStore.locale

      return fetch( `${this.config.API}service/request?id=${id}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify( form )
      } )
    }

    this.setLastLocation = ( location ) => {
      console.log( "lastLocation", location )
      this._lastLocation = location
    }

    this.service.params = ( files ) => {
      let p = files.map( file => this.service.upload( file ) )
      return Promise.all( p )
    }

    this.service.upload = ( file ) => {
      let formData = new FormData()
      formData.append( `file-${file.name}`, file )
      let isError = false
      return fetch( `${this.config.API}/service/params`, {
        method: "POST",
        credentials: 'include',
        body: formData
      } )
        .then( res => {
          if ( res.status >= 400 && res.status < 600 ) {
            isError = true
            return res
          }
          return res
        } )
        .then( res => res.text() )
        .then( id => {
          if ( isError ) {
            window.swal( "Fehler beim Upload", id, "error" )
            throw new Error( id )
          }
          return { file, id }
        } )
    }

    this.session = false
    this.hasSession = function () {
      return this.session || false
    }

    this.hasRole = function ( role ) {
      return this.session && this.session.user && _.includes( this.session.user.roles, role )
    }

    this.Filter = Filter

    // CMS access
    this.page = this.cms = function ( slug ) {
      let url = this.config.CMS + "pages?slug=" + slug + app.getQueryLanguageParameter()
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( page => page[ 0 ] )
        .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", slug, err ) )
    }

    this.form = this.cms = function ( slug ) {
      let url = this.config.CMS + "bshop-form?slug=" + slug + app.getQueryLanguageParameter()
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .catch( err => console.error( "CMS Module (Form) Error", err ) )
    }

    this.post = function ( slug ) {
      console.log( `get post`, slug )
      //http://bshopdemo.trend-soft.de/wp/wp-json/wp/v2/
      let url = this.config.CMS + "posts?slug=" + slug + app.getQueryLanguageParameter()
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
    }

    this.getCMSModule = function ( slug ) {
      return this.getCMSContent( slug )
                 .then( page => page[ 0 ].acf )
                 .catch( e => {
                   console.error( e )
                 } )
    }

    this.getCMSContent = function ( slug ) {
      let url = this.config.CMS + "shop?slug=" + slug + app.getQueryLanguageParameter()
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .catch( err => console.error( "CMS Module Error", err ) )
    }

    this.getFrontPage = function () {
      let url = `${this.config.CMS}options/page_on_front`
      return fetch( url, { mode: "cors" } )
        .then( response => response.json() )
        .then( options => options.page_on_front )
        .then( pageId => {
          let frontpageUrl = `${this.config.CMS}pages/${pageId}` + app.getQueryLanguageParameter( "?" )
          return fetch( frontpageUrl, { mode: "cors" } )
            .then( response => response.json() )
            .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", pageId, err ) )
        } )
        .catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", url, err ) )
    }

    this.cart = new Cart( { api: this } )

    // events
    this.events.authentified.add( () => {
      this.cart.hydrate()
      $fetch.clear()
    } )

    this.events.logout.add( () => {
      $fetch.clear()
      sessionStorage.clear()
    } )

    let categoriesById = this.categoriesById
    window.api = this
  }


  loadCategories = () => {
    const parseCategoryNames = ( category ) => {
      _.each( category.children, ( cat ) => {
        parseCategoryNames( cat )
      } )
      this.categoriesById.set( category.map_id, category )
      this.store.categories.categoriesById.set( category.map_id, category )
    }

    // load all categories and push the app into ready
    return this.store.categories.fetch( this )
               .then( categories => {
                 this.categories = categories
                 _.each( categories, ( cat ) => {
                   parseCategoryNames( cat )
                 } )
                 this.events.loaded.dispatch()
               } )
  }

  requestPassword( email ) {
    return this.fetch( `/shop/rest/security/requestresetpass?email=${encodeURIComponent( email )}` )
  }

  resetPassword( { key, subkey, password } ) {
    return this.fetch( "/shop/rest/security/resetpass", {
      method: "POST",
      body: JSON.stringify( {
                              subkey: Number( subkey ),
                              key: key,
                              password: password
                            } ),
      headers: {
        "content-type": "application/json; charset=utf-8"
      }
    } )
  }

  handleError = ( request ) => {
    console.warn( "Error:", request )
    throw new Error( request )
  }

  fetch( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return fetch( this.config.BASE + endpoint, opts )
      .then( this.handleResponse )
      .catch( this.handleError )
  }

  fetchText( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return fetch( this.config.BASE + endpoint, opts )
      .then( res => {
        if ( res.status !== 200 ) {
          return false
        } else {
          return res.text()
        }
      } )
  }

  handleResponse = res => {
    if ( res.status && res.status < 400 ) {
      return res.json()
    } else {
      return res.text()
                .then( error => {
                  throw error
                } )
    }
  }

  fetchFromWordPress( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return fetch( this.config.CMS + endpoint, opts )
      .then( res => res.json() )
      .catch( this.handleError )
  }

  fetchFromWordPressBase( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return fetch( this.config.CMS_BASE + endpoint, opts )
      .then( res => res.json() )
      .catch( this.handleError )
  }

  fetchCached( endpoint, opts = {} ) {
    opts = Object.assign( opts, defaultFetchConfig )
    return $fetch( this.config.BASE + endpoint, opts )
  }


  getCategoryParents( categoryId ) {
    let cat = this.categoriesById.get( categoryId )
    if ( !cat ) return []
    let parents = [cat]
    while (cat) {
      cat = this.categoriesById.get( cat.parent )
      if ( cat ) {
        parents.push( cat )
      }
    }
    parents.reverse()
    return parents.map( c => c.map_id )
  }

  getCategoryPath( id, { base = "/collection" } = {} ) {
    let cat = this.categoriesById.get( id )
    if ( !cat ) return []
    let parents = [cat]
    while (cat) {
      cat = this.categoriesById.get( cat.parent )
      if ( cat ) {
        parents.push( cat )
      }
    }

    parents.reverse()

    let parentPath = base
    let out = parents.map( cat => {
      const link = `${parentPath}/${cat.map_id}`
      parentPath = link
      return {
        title: cat.desc.short_des,
        link
      }
    } )

    return out
  }

  categoryName( id ) {
    let cat = this.categoriesById.get( id )
    if ( cat ) {
      return cat.desc.short_des
    } else {
      console.warn( `Category ${id} not found` )
      return ""
    }
  }

  _prepareCategories = ( config ) => {
    try {
      this.product = productStore.get
      this.products = new Products( this, config )
      this.Filter = Filter
      this.analytics = new Analytics()
      this.orderlist = new OrderlistService( { shop: this } )
      this.categories = []
      let d = store.get( "categoriesById" ) || "[]"
      let a = JSON.parse( d )
      this.categoriesById = new Map( a )
      this.toast = toast
    }
    catch (e) {
      console.error( "ERROR_CATEGORY_PARSE", e )
    }
  }


  setPassword( { newPassword, oldPassword } ) {
    return this.fetch( "/shop/rest/security/setpassword", {
      method: "POST",
      body: JSON.stringify( {
                              newPassword,
                              oldPassword
                            } ),
      credentials: 'include',
      headers: {
        "content-type": "application/json; charset=utf-8"
      }
    } )
  }
}

const defaultFetchConfig = {
  mode: "cors",
  credentials: "include"
}

const toast = ( msg, type = "info", stay = false, position = "top", options = {} ) => {
  notie.alert( {
                 type: type, // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                 text: msg,
                 stay, // optional, default = false
                 position, // String // optional, default = 'top', enum: ['top', 'bottom'],
                 ...options
               } )
}

window.notie = notie

if ( window ) window.Api = Api



// WEBPACK FOOTER //
// ./src/sdk/Api.js